import * as types from '../mutation-types'
import { API } from '../../api'
import { SHARE } from '../../share'
import { FATE_DATA_MANAGER, BASE_DATA_MANAGER } from '../../data'
import FateFortuneStore from '../plugins/fatefortune'
import { CONFIG } from '../../config'

export default {
    namespaced: true,
    modules: {
        fatefortune: FateFortuneStore
    },
    state: {
        initDetail: false,
        hideName: false,
        personInfo: {},
        showDetailType: 1,  //0资料,1流运,2神煞,3关系
        detailInfoData: {},
        detailShenShaList: [],
        updateRelation: true,
        detailRelationList: [],
        showQrCodePop: false,
        qrCodeValue: '',
        showPipanLunpanPop: false,
        showDetailSharePop: false,
        gotBaziNum: false,
        baziNumData: {},
        isLocalDetail: false,
        hideBottomBar: false,
    },
    getters: {},
    mutations: {
        [types.DETAIL_INIT_DATA](state, personData) {
            console.log("types.DETAIL_INIT_DATA---排盘详情:::::", personData);
            var detailData = FATE_DATA_MANAGER.getDetailFateDataByData(personData, 'detail');
            state.initDetail = true;
            state.personInfo = personData;
            state.detailInfoData = detailData.detailInfo;
            state.baziNumData.pipan = personData.pipan;
            state.baziNumData.otherpipan = personData.otherpipan;
            state.baziNumData.nunpan = personData.nunpan;
            
            // 初始化命盘运盘信息
            AppFate.$store.dispatch('detail/fatefortune/initDetailFateFortune', detailData);

            // 更新二维码地址和分享配置信息
            setTimeout(() => {
                AppFate.$store.dispatch('detail/updateQrCodeValue');
                // 设置命局类型+强弱类型的文本
                AppFate.$store.dispatch('detail/updateSituationString', personData.situation);
                AppFate.$store.dispatch('detail/updateStrongString', personData.strong);
                // 设置标签数据
                AppFate.$store.dispatch('label/resetSelectedData');
                AppFate.$store.dispatch('label/initLabelList', {
                    cb: function() {
                        AppFate.$store.dispatch('label/initSelectedLabelFromDetail', state.personInfo);
                    }
                });
                SHARE.initConfigShare();
            }, 100);
        },
        [types.DETAIL_INIT_LOCAL_DATA](state, params) {
            console.error('DETAIL_INIT_LOCAL_DATA---本地排盘::::::', params);
            var personData = params.formData;
            var detailData = FATE_DATA_MANAGER.getDetailFateDataByData(personData, 'detail');
            state.initDetail = true;
            state.personInfo = personData;
            state.detailInfoData = detailData.detailInfo;
            state.isLocalDetail = true;
            state.hideBottomBar = true;
            // 初始化命盘运盘信息
            AppFate.$store.dispatch('detail/fatefortune/initDetailFateFortune', detailData);

            if(params.cb && typeof(params.cb) == 'function'){
                params.cb();
            }
        },
        [types.DETAIL_INIT_DETAIL_SHEN_SHA](state) {
            // var fateList = state.fateListData;
            var fateList = AppFate.$store.state.detail.fatefortune.fateListData,
                fateSideList = AppFate.$store.state.detail.fatefortune.fateSideListData,
                allList = fateList.concat(fateSideList);
            console.log('types.DETAIL_INIT_DETAIL_SHEN_SHA', fateList, allList)
            
            var curLength = state.detailShenShaList.length;
            // 判断是否需要重复请求
            if(curLength != allList.length){
                state.detailShenShaList = FATE_DATA_MANAGER.getDetailShenShaListByList(fateList, allList);
            }
        },
        [types.DETAIL_INIT_DETAIL_HE_HUA_CHONG](state) {
            var fateList = [].concat(AppFate.$store.state.detail.fatefortune.fateListData),
                fateSideList = [].concat(AppFate.$store.state.detail.fatefortune.fateSideListData),
                settingConfigData = Object.assign({}, AppFate.$store.state.setting.settingConfigData),
                allList = [];
            if(parseInt(settingConfigData.nianyueRishi) == 1) {
                fateList.reverse(); fateSideList.reverse();
            }
            allList = parseInt(settingConfigData.sizhuGeShi) == 1 ? fateSideList.concat(fateList) : fateList.concat(fateSideList);
            if(state.updateRelation) {
                state.detailRelationList = FATE_DATA_MANAGER.getDetailRealationListByList(fateList, allList);
                state.updateRelation = false;
            }
            console.log('types.DETAIL_INIT_DETAIL_HE_HUA_CHONG', state.detailRelationList)
        },
        [types.DETAIL_UPDATE_QR_CODE_VALUE](state) {
            // 更新二维码链接
            var shareId = state.hideName ? state.personInfo.share : state.personInfo.share2;
            if(CONFIG.platform == 'wechat') {
                state.qrCodeValue = 'https://' + location.hostname + '/share/detail/' + shareId + '-save1';
            }else if(CONFIG.platform == 'qq') {
                state.qrCodeValue = 'https://' + location.hostname + '/qq?path=share-detail-' + shareId + '-save1';
            }
            console.log('types.DETAIL_UPDATE_QR_CODE_VALUE----', state.qrCodeValue)
        },
        [types.DETAIL_UPDATE_SITUATION_STRING](state, situation) {
            var situationList = AppFate.$store.state.base.situationList;
            state.detailInfoData.situationStr = BASE_DATA_MANAGER.getBaseDataTextById(situationList, parseInt(situation));
        },
        [types.DETAIL_UPDATE_STRONG_STRING](state, strong) {
            var strongList = AppFate.$store.state.base.strongList;
            state.detailInfoData.strongStr = BASE_DATA_MANAGER.getBaseDataTextById(strongList, parseInt(strong));
        },
        [types.DETAIL_RESET_DATA](state) {
            state.initDetail = false;
            state.hideName = false;
            state.personInfo = {};
            state.showQrCodePop = false;
            state.qrCodeValue = '';
            state.showPipanLunpanPop = false;
            state.showDetailSharePop = false;
            state.gotBaziNum = false;
            state.baziNumData = {};
            state.isLocalDetail = false;
            state.hideBottomBar = false;

            // 重置命盘运盘信息
            AppFate.$store.dispatch('detail/fatefortune/resetDetailData')

            // 重置底部tab数据
            state.showDetailType = 1;
            state.detailInfoData = {};
            state.detailShenShaList = [];
            state.updateRelation = true;
            state.detailRelationList = [];
        }
    },
    actions: {
        initDetail({ commit }, personData) {
            commit(types.DETAIL_INIT_DATA, personData);
        },
        initLocalDetail({ commit }, personData) {
            commit(types.DETAIL_INIT_LOCAL_DATA, personData);
        },
        initDetailShensha({ commit }) {
            commit(types.DETAIL_INIT_DETAIL_SHEN_SHA)
        },
        initDetailHehuachong({ commit }) {
            commit(types.DETAIL_INIT_DETAIL_HE_HUA_CHONG)
        },
        updateQrCodeValue({ commit }) {
            commit(types.DETAIL_UPDATE_QR_CODE_VALUE);
        },
        updateSituationString({ commit }, situation) {
            commit(types.DETAIL_UPDATE_SITUATION_STRING, situation)
        },
        updateStrongString({ commit }, strong) {
            commit(types.DETAIL_UPDATE_STRONG_STRING, strong)
        },
        updateDetailGlanceTime({ state }, personData) {
            // 服务器上报浏览时间更新
            API.changeGlanceTime({
                id: personData.id
            }, function(data){
                if(data.ret){ console.log("更新查看时间:::", personData.f_name) }
            });
        },
        updateDetailPipanStatus({ state }) {
            state.personInfo.pipan = 1;
            state.baziNumData.pipan = 1;
        },
        updateDetailLunpanStatus({ state }) {
            state.personInfo.nunpan = 1;
            state.baziNumData.nunpan = 1;
        },
        updateDetailLabelStatus({ dispatch, state }, params) {
            API.updatePaiPan({
                id: state.personInfo.id,
                label: params.label,
                remark: params.remark
            }, function(data) {
                console.log('更新命盘数据成功:::::::', data);
                state.personInfo.label = params.label;
                state.personInfo.remark = params.remark;
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                // 更新列表数据
                dispatch('record/updateRecordListData', state.personInfo, {root: true});
            })
        },
        getBaziNum({state}) {
            if(state.gotBaziNum) { 
                state.showPipanLunpanPop = true;
                return;
            }
            API.getBaziNum({
                id: state.personInfo.id
            }, function(data) {
                console.log('获取八字统计数据成功:::::', data.ret);
                state.gotBaziNum = true;
                state.baziNumData = data.ret;
                state.showPipanLunpanPop = true;
            })
        },
        resetData({ commit }){
            commit(types.DETAIL_RESET_DATA);
        }
    }
}